import {Outlet} from 'react-router-dom';
import styled  from '@emotion/styled';


const  backgroundImage = '/public-assets/account-back.png';
const logo = '/public-assets/logo.png';
const Wrapper = styled.main`
  width: 100dvw;
  height:100dvh;
  display: flex;
  & > section:first-of-type{
    width:50%;
    height :100% ;
    background-position: center;
    background-size:cover;
  }
  & > section:nth-of-type(2){
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: var(--dark-green-background);
    width:50%;
    height:100%;
    & > div:first-of-type{
      height: 150px;
      width:100%;
      display: flex;
      justify-content: center;
      align-items: center;
      & > img{
        width:60px;
        height:60px;
        object-fit: contain;
        object-position: center;
      }

    }
  }
`

const Account = () => {
  return (
    <Wrapper>
      <section style={{backgroundImage:`url(${backgroundImage})`}}>

      </section>
      <section>
        <div>
          <img src={logo} alt="logo" />
        </div>
        <div>
          <Outlet />
        </div>
      </section>

    </Wrapper>
  )
}

export default Account;



